import { render } from "./taskDesk.vue?vue&type=template&id=6f97ecdf&scoped=true"
import script from "./taskDesk.vue?vue&type=script&lang=js"
export * from "./taskDesk.vue?vue&type=script&lang=js"

import "./taskDesk.vue?vue&type=style&index=0&id=6f97ecdf&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-6f97ecdf"

export default script